import React from 'react'
import styled from 'styled-components'
import { string } from 'prop-types'
import Textbox from '@taglivros/oef_componentes/build/components/textbox'

const ImageWrapper = styled.div`
  margin-top: 10px;
  margin-bottom: 30px;
  img {
    box-shadow: rgba(19, 26, 45, 0.2) 0px 1px 4px;
  }
`

const CodigoPix = ( { codigoPix, urlQrCode } ) => {
  return (
    <>
      <ImageWrapper>
        <img
          alt="QrCode"
          src={ urlQrCode }
        />
      </ImageWrapper>

      <Textbox
        buttonValue="Copiar"
        isCopy
        label="Código do PIX"
        name="codigo-pix"
        tipo="text"
        value={ codigoPix }
      />
    </>
  )
}

CodigoPix.propTypes = {
  'codigoPix': string.isRequired,
  'urlQrCode': string.isRequired,
}

export default CodigoPix


